
export enum StatusFilaEnum {
  Aguardando = 'Aguardando',
  Processando = 'Processando',
  Finalizado = 'Finalizado',
  Error = 'Error',
}
